<script>
    import { onMount } from 'svelte';
    import Button from 'views/components/button/Button.svelte';
    import TaskGroup from 'views/components/taskGroups/TaskGroup'

    const {
        activityModel,
        taskGroupModel,
        onNextTaskGroupCallback,
        mode = 'make'
    } = $props()

    let taskGroupView
    let nextTaskGroupIsLoading = $state(false)
    let isCheckingAnswers = $state(mode === 'review')

    // Prevent students from accidentally losing their progress
    onMount(() => {
        window.onbeforeunload = (event) => event.preventDefault()

        return () => window.onbeforeunload = undefined
    })

    function renderTaskGroup(element) {
        taskGroupView = new TaskGroup({
            model: taskGroupModel,
            work_on: {
                el: element,
                model: activityModel
            }
        })
        element.append(taskGroupView.el)

        if (mode === 'review') {
            for (const taskView of taskGroupView.taskViews) {
                taskView.showAnswer()
            }
        }
    }

    function onClickCheckAnswers() {

        // Check if all tasks on the taskgroup have a response
        if (ACL.checkRole(ACL.roles.STUDENT)) {
            for (const task of taskGroupModel.tasks) {
                const response = activityModel.responses.find({ task_id: task.id })
                if (!response || !response.has('json_answer')) {
                    Backbone.View.layout.openStatus(
                        window.i18n.gettext('Answer the question first before checking the correct answer.'),
                        'info'
                    )
                    return
                }
            }
        }

        isCheckingAnswers = true
        for (const taskView of taskGroupView.taskViews) {
            taskView.showAnswer()
        }
    }

    function onClickNextTaskgroup() {
        nextTaskGroupIsLoading = true
        onNextTaskGroupCallback()
    }
</script>

<div class="center-panel">
    <div use:renderTaskGroup></div>

    <div class="button">
        {#if isCheckingAnswers}
            <Button
                label={window.i18n.gettext('Next taskgroup')}
                iconRight="arrow-right"
                disabled={nextTaskGroupIsLoading}
                hasSpinner={nextTaskGroupIsLoading}
                callback={onClickNextTaskgroup}>
            </Button>
        {:else}
            <Button
                label={window.i18n.gettext('Check answers')}
                icon="lightbulb"
                callback={onClickCheckAnswers}>
            </Button>
        {/if}
    </div>
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.button {
  display: flex;
  max-width: 1024px;
  margin: 32px auto 0 auto;
  padding-left: 84px;
  padding-bottom: 36px;
}</style>
